import ClientAvatars from '@v2/components/ui/ClientAvatars';

type Props = {
    clients: string[];
};

export default function ShipmentClientsCell({ clients }: Props) {
    return <ClientAvatars names={clients} maxVisible={4} size="sm" />;
}
